import { cn } from "../lib/cn";

interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  description?: string;
  align?: "left" | "center";
}

/** Eyebrow + balanced title + optional description. Opens every section. */
export function SectionHeading({
  eyebrow,
  title,
  description,
  align = "left",
}: SectionHeadingProps) {
  return (
    <div
      className={cn("max-w-3xl", align === "center" && "mx-auto text-center")}
    >
      <p className="text-accent mb-3 text-sm font-semibold tracking-eyebrow uppercase">
        {eyebrow}
      </p>
      <h2 className="text-strong text-2xl leading-tight font-semibold tracking-tight text-balance md:text-3xl">
        {title}
      </h2>
      {description ? (
        <p className="text-muted mt-5 text-base leading-7 text-pretty md:text-lg">
          {description}
        </p>
      ) : null}
    </div>
  );
}
